module.exports = __webpack_public_path__ + "img/newStop.acb295f8.png";